__turbopack_context__.v({
  "className": "host_grotesk_aa5b9219-module__s7c6aW__className",
});
